import * as React from 'react';

import { Icon } from '@rbilabs/components-library';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

import { isExternalLink } from 'utils/is-external-link';

import { LinkContainerStyles, LinkStyles } from './styles';
import { useLogNavigationClick } from './use-log-navigation-click';

export const StyledLink = styled(Link)`
  ${LinkContainerStyles}
  ${LinkStyles}
`;
export const StyledAnchor = styled.a`
  ${LinkContainerStyles}
  ${LinkStyles}
`;

export const ArrowLink: React.FC<React.ComponentProps<typeof StyledLink | typeof StyledAnchor>> = ({
  children,
  eventName,
  onClick,
  ...props
}) => {
  const handleClick = useLogNavigationClick(eventName, onClick);

  return isExternalLink(props.to) ? (
    <StyledAnchor href={props.to} target="_blank" onClick={handleClick}>
      {children}
      <Icon icon="next" color="icon-default" width="16px" aria-hidden data-testid="icon" />
    </StyledAnchor>
  ) : (
    <StyledLink {...props} onClick={handleClick}>
      {children}
      <Icon icon="next" color="icon-default" width="16px" aria-hidden data-testid="icon" />
    </StyledLink>
  );
};
